import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromRouting from './routing.reducer';

const getRoutingState = createFeatureSelector<fromRouting.RoutingState>(
  fromRouting.ROUTING_FEATURE_KEY,
);

export const getRecentRoutes = createSelector(
  getRoutingState,
  (state) => state.recentRoutes,
);
